module.exports = __webpack_public_path__ + "static/media/SWSCRC1-21.4c485776.mp3";